import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ListBasketItems from "./ListBasketItems"
import classNames from 'classnames'
import showBasketStatus from "../../../vietnamese/showBasketStatus"
import showLocationType from "../../../vietnamese/showLocationType"
import ReleaseBasketButton from "../actions/ReleaseBasketButton"
import ExportQrCode from "../actions/ExportQRCode"
import { Popover } from 'antd'
import { getDetailBarcode } from '../../../services/api/3dApi'
import { Icon, Modal, Button } from 'antd'
import _ from "lodash"
import printImageV2 from '../../../helpers/printQRCode/printImageV2'
import makeImageLabels from '../../../helpers/printQRCode/makeImageLabels'
import { listLineship } from '../helpers/Data.json'
import compareSize from '../../../helpers/printQRCode/compareSize'
import { convertDateOverTimeNew } from '../helpers/convertDateOverTime'

class BasketDetail extends Component {

    state = {
        orderData: {},
        image: '',
        isOpenPreview: false,
    }

    fetchOrderData = async (barcode) => {
        try {
            const { data: response } = await getDetailBarcode(barcode)
            const { data, success, error } = response
            if (!success) {
                throw new Error(error)
            }
            this.setState({
                orderData: data
            })
        } catch (error) {
            console.log('error', error)
        }
    }

    componentDidMount() {
        const { result } = this.props
        const { items = [], order_number = '' } = result || {}
        const itemhasOrderData = items.find(i => !!i.orderData)
        const { orderData = {} } = itemhasOrderData || {}
        if (!!itemhasOrderData) {
            this.setState({
                orderData: orderData
            })
            return
        }
        this.fetchOrderData(`${order_number}_1`)
    }

    componentDidUpdate(prevProps) {
        if (prevProps.result !== this.props.result) {
            const { result } = this.props
            const { items = [], order_number = '' } = result || {}
            const itemhasOrderData = items.find(i => !!i.orderData)
            const { orderData = {} } = itemhasOrderData || {}
            if (!!itemhasOrderData) {
                this.setState({
                    orderData: orderData
                })
                return
            }
            this.fetchOrderData(`${order_number}_1`)
        }
    }

    renderTypeBasket = (type = '') => {
        switch (type) {
            case 'normal':
                return 'Đơn thường'
            case 'combo_fac':
                return 'Combo FAC'
            case 'combine_ship':
                return 'Gộp ship'
            default:
                return ''
        }
    }

    _handleChangeImage = (url = '', open = false) => {
        this.setState(preState => ({
            ...preState,
            image: url,
            isOpenPreview: open
        }))
    }

    _LineShipName = (lineShip) => {
        if (!!lineShip) {
            const mappingLineShips = [
                ...listLineship,
                { value: 'usps_mn_ib_blue', name: 'USPS-IB' },
                { value: 'ib_blue_usps_mn', name: 'IB-USPS' },
            ]
            const lineShipName = mappingLineShips.filter(item => item.value === lineShip)

            return lineShipName[0]
        }
    }

    _parseSize = (size) => {
        if (size === null || size === undefined) return { size }

        const vSize = String(size).replace(/\s/g, '')
        const parsed = vSize.match(/^(.*?)-NOCARD$/i)

        if (parsed) {
            return {
                size: parsed[1].trim(),
                noCard: true,
            }
        }
        return { size: vSize }
    }

    _parseInfo = (info) => {
        const results = []
        const usex = ['PR', 'AE', 'AP', 'AO', 'VI', 'AA']
        const { barcode: item, items = [] } = info || {}
        const { products: barcodeProducts = [] } = item || {}
        //Đếm tổng các item có cùng barcode
        const counts = (Array.isArray(items) ? items : []).reduce((acc, it) => {
            const orderId = it.barcode || ''
            const prefix = !!orderId ? (String(orderId).split('_')[0] || '') : ''
            if (!prefix) return acc
            acc[prefix] = (acc[prefix] || 0) + 1
            return acc
        }, {})

        const products = Array.isArray(items) && items.length > 0 && items.every(i => !!i.meta && !!i.meta.product) ?
            items.filter(i => !i.is_cancelled && !['cancelled', 'cancel-ship'].includes(i.sub_status) && !['cancelled', 'cancel-ship'].includes(i.status))
                .map(i => {
                    const prefix = !!i.barcode ? (String(i.barcode).split('_')[0] || '') : ''
                    return {
                        ...(!!i.meta && i.meta.product),
                        overtime: i.overtime,
                        barcode: i.barcode,
                        totalItem: counts[prefix] || 1,
                    }
                }) :
            (Array.isArray(barcodeProducts) ?
                barcodeProducts.filter(i => !i.is_cancelled && !['cancelled', 'cancel-ship'].includes(i.sub_status) && !['cancelled', 'cancel-ship'].includes(i.status))
                    .map(i => {
                        const prefix = !!i.barcode ? (String(i.barcode).split('_')[0] || '') : ''
                        return {
                            ...i,
                            overtime: (i.remaining_time > 0 ? -i.remaining_time : i.overtime),
                            barcode: `${item.barcodeNumber}_${i.pos}`,
                            totalItem: barcodeProducts.length,
                        }
                    }) : [])

        const { barcodeNumber, country = '', state = '', shipping_level, labelDetails, tags: genericTags = [], order_type } = { ...item }
        const { shipping_carrier, meta } = { ...labelDetails }
        const isFastProduction = Array.isArray(genericTags) && genericTags.includes('fastproduction')
        const isCutoff = Array.isArray(genericTags) && genericTags.includes('cutoff')
        const isHQ = Array.isArray(genericTags) && (genericTags.includes('HQ') || genericTags.includes('HQ gap'))
        const hasCombineShipTag = genericTags.some(item => /^combine-ship(-\w+)?$/.test(item))
        const tagHasCombineShipId = genericTags.find(item => /^combine-ship-\w+$/.test(item)) || ''
        const combineShipId = !!tagHasCombineShipId ? tagHasCombineShipId.replace('combine-ship-', '') : ''
        const comboTag = genericTags.filter(i => !!i && ['BM_TC', 'BM_LAB', 'TC_LAB', 'BM_TC_LAB', 'COMBO_SOCKS'].includes(i.toUpperCase()))
        for (let i in products) {
            const product = products[i]
            const {
                barcode,
                color,
                size,
                designFront,
                designBack,
                designSleeveLeft,
                designSleeveRight,
                tags = [],
                brand_name,
                brand_rule,
                remaining_time,
                overtime,
            } = { ...product }
            const lineShipName = shipping_carrier ? (!!this._LineShipName(shipping_carrier).name ? this._LineShipName(shipping_carrier).name : '') : ''
            let line_ship_label = lineShipName === "ZONE9_US" ? "HW_Z9" : lineShipName === "ZONE9_CA" ? "Z9_CA" : lineShipName === "ITC Standard" ? "ITC DHL" : lineShipName
            let hwUSPSArea = ''

            if (['hw_usps'].includes(shipping_carrier)) {
                hwUSPSArea = meta && meta.area || 'NY'
            }

            if (['hw_tiktok', 'hw_ttship', 'hw_gb', 'hw_gb_ttship'].includes(shipping_carrier)) {
                hwUSPSArea = meta && meta.area || ''
            }

            const brandName = brand_name ? brand_name : ''
            const isNoCard = brand_rule && brand_rule.is_no_card ? brand_rule.is_no_card : false
            const isSpecialTag = Array.isArray(tags) && tags.includes('priority-store')
            const { size: vSize, noCard } = this._parseSize(size)
            const pos = product.hasOwnProperty('pos') ? product.pos : (i + 1)
            const side = `${designFront ? 'F' : ''}${designBack ? 'B' : ''}${(designSleeveLeft || designSleeveRight) ? '-' : ''}${designSleeveLeft ? 'L' : ''}${designSleeveRight ? 'R' : ''}`
            const type = product.type
            let loc = ''

            if (country.toUpperCase() === 'US' && usex.indexOf(state.toUpperCase()) !== -1) {
                loc = "WW"
            } else {
                loc = country.toUpperCase()
            }

            // FAC-24531: đơn HW_YUN giao vào EU thực tế đi DHL và đóng sang thùng HW_EU
            // nên QR phải in HW_EU.
            //
            // Danh sách country phải khớp nhóm nước HW route qua DHL, khai báo trong
            // label-service src/adapters/hw-yun/getTrackingUrl.js. Bên đó list bị tách
            // theo domain tracking (NL dùng dhl.com, nhóm còn lại dùng dhl.de) nên grep
            // nguyên mảng này sẽ không ra — quy tắc đối chiếu: nước nào bên label-service
            // KHÔNG rơi vào return cuối (yuntrack.com) thì phải có trong mảng dưới đây.
            //
            // Thêm nước mới phải sửa 4 chỗ: file này + 3 chỗ bên fulfillment-webapp
            // (views/QRCode/actions/printQR.js, views/ExportQRItems/ExportQRItems.js,
            // views/ListItemsV5/ListCardHeaderActions/ExportQR.js).
            if (['HW_YUN'].includes(line_ship_label) && ['AT', 'CZ', 'DE', 'HU', 'IT', 'LU', 'NL', 'PL'].includes(loc) && !genericTags.includes('force-yun')) {
                line_ship_label = 'HW_EU'
            }

            const label = {
                orderId: barcode,
                total: product.totalItem,
                pos: pos,
                posColor: product.totalItem > 1 ? 'white' : 'black',
                posBackground: product.totalItem > 1 ? (isSpecialTag ? '#6d1212' : 'black') : 'white',
                color: color,
                size: vSize,
                side: side,
                sideBackground: side === 'F' ? (isSpecialTag ? '#6d1212' : 'white') : (isSpecialTag ? '#6d1212' : 'black'),
                sideColor: side === 'F' ? (isSpecialTag ? 'white' : 'black') : 'white',
                type: type,
                noCard,
                loc: loc,
                isSpecialTag,
                brand_name: brandName,
                is_no_card: isNoCard,
                line_ship_label,
                overtime: convertDateOverTimeNew(overtime),
                tagMTUS: (Array.isArray(genericTags) && genericTags.includes('MT_US_NHE')) ? "MT_US_NHE" : "",
                hwUSPSArea,
                isFastProduction,
                isCutoff,
                isHQ,
                order_type,
                isCombineShip: hasCombineShipTag,
                comboTag: comboTag,
                isCombo: comboTag.length > 0,
                genericTags,
                tags,
                combineShipId: combineShipId,
            }
            results.push(label)
        }

        const sortedLabels = [...results]
            .sort((a, b) => {
                if (a.color > b.color) return 1
                if (a.color < b.color) return -1

                const cpSize = compareSize(a.size, b.size)

                if (cpSize) return cpSize

                if (a.side > b.side) return 1
                if (a.side < b.side) return -1
                if (a.orderId > b.orderId) return 1
                if (a.orderId < b.orderId) return -1
                if (a.orderId > b.orderId) return -1
                if (a.orderId < b.orderId) return 1

                return 0
            })

        return sortedLabels
    }

    _handleClickPrintQR = async (data) => {
        try {
            const labels = this._parseInfo(data)
            const image = await makeImageLabels(labels, 560, 300, 1)
            printImageV2(image)
        } catch (err) {
            Modal.error({
                title: 'Lỗi',
                content: err.message,
                okText: 'Đóng',
            })
        }
    }

    render() {
        const { result, disabledCheckExists, isAppliedBrandingForAllItems, onSetData, reload, containerRef } = this.props
        const { completed_items, exists, items = [], number, location, order_number, status, total_items, order_numbers = [], type = '', barcode: resultBarcode = {} } = result || {}
        const vItems = Array.isArray(items) ? items : []
        const action = exists ? 'Đã có giỏ' : 'Giỏ mới'
        const badge = exists ? 'badge-success' : 'badge-info'
        const tagsRule = _.get(this.state.orderData, 'meta.brand.rule.tags') || []
        const imagePackaging = tagsRule.filter(i => _.get(i, "type") === "packaging") || []
        const isShowImagePackaging = !!imagePackaging.length && _.get(this.state.orderData, 'meta.brand.rule.brand.name') === "ZENITH"
        // const allItemsCompleted = vItems.every(i => i.status === 'completed')
        const filterItems = vItems.filter(i => ["THANK_CARD", "BRAND_KIT", "GIFTCARD_1800NO"].includes(i.product_type))
        const listItemNotSpecal = vItems.filter(i => !["THANK_CARD", "BRAND_KIT", "GIFTCARD_1800NO"].includes(i.product_type)) || []
        const isShowButtonQC = listItemNotSpecal.every(i => i.status === "completed")
        const showImg = !!filterItems.length
        // const imgLink = !!filterItems.length ? filterItems.map(i => !!i.orderData && (i.orderData.design_front || i.orderData.preview_image)) : []
        const brandingItems = filterItems.length && filterItems.reduce((mem, item) => {
            return {
                ...mem,
                [item.product_type]: mem[item.product_type] ? mem[item.product_type] + 1 : 1
            }
        }, {})

        const { orderData = {} } = this.state
        const { tags: orderTags = [] } = orderData || {}
        const { tags: barcodeTags = [] } = resultBarcode || {}
        const isMadeInVN = orderTags.includes('made_vn')
        const isComboSock = orderTags.includes('combo_socks')
        const isNoProof = barcodeTags.includes('no_proof')
        const is24h = orderTags.includes('24h')

        return (
            <div className={classNames("BasketDetail", { exists: !!exists }, status, location)}>
                <div className="Huge">
                    {
                        isAppliedBrandingForAllItems &&
                        <p className="alert alert-danger">BrandKit theo item</p>
                    }
                    <div className={`BasketInfo ${(!!showImg || isShowImagePackaging) ? 'row' : ''} `}>
                        <div className={`InfoRight ${((!!showImg && !isShowImagePackaging) || (!!showImg && isShowImagePackaging)) ? 'col-6' : (!showImg && isShowImagePackaging) ? 'col-8' : ''}`}>
                            <div className="row mb-3">
                                <div className="col-6 text-right">Số giỏ</div>
                                <div className="col-6">
                                    <h4>
                                        <span className="BasketNumber">{number}</span>
                                        <span className="TotalItems">/{total_items}</span>
                                        {
                                            !disabledCheckExists &&
                                            <span className={classNames("Action ml-5 badge", badge)}>{action}</span>
                                        }
                                    </h4>
                                </div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-6 text-right">Hoàn thành</div>
                                <div className="col-6 d-flex">
                                    <h4 className='mb-0 mr-3'>{completed_items} / {total_items}</h4>
                                    <div className='d-flex align-items-center mx-3'>
                                        <Button type={'primary'} size={'large'} onClick={() => this._handleClickPrintQR(result)}>Print QR</Button>
                                    </div>
                                </div>
                            </div>

                            <div className="row mb-3 row-order-number">
                                <div className="col-6 text-right">Số đơn</div>
                                <div className="col-6">
                                    <h4>
                                        {
                                            !!order_numbers.length ?
                                                order_numbers.map(i => `#${i}`).join(', ') :
                                                `#${order_number}`
                                        }
                                        {
                                            !!brandingItems && <div className="branding-count">
                                                {
                                                    Object.keys(brandingItems).map((type, index) => {
                                                        return <span className={`branding-${type}`} key={index}>
                                                            <strong className="badge badge-danger">{brandingItems[type]}</strong>
                                                            <span>{type}</span>
                                                        </span>
                                                    })
                                                }
                                            </div>
                                        }
                                    </h4>
                                </div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-6 text-right">Loại đơn</div>
                                <div className="col-6"><h4>{showLocationType(location)}</h4></div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-6 text-right">Trạng thái</div>
                                <div className="col-6">
                                    <h4>{showBasketStatus(status)}</h4>
                                    <div className="Tags">
                                        {
                                            isMadeInVN &&
                                            <span className="tagVN mr-2 mb-2">Made in VN</span>
                                        }
                                        {
                                            isComboSock &&
                                            <span className="tagVN mr-2 mb-2">COMBO SOCKS</span>
                                        }
                                    </div>
                                    <div className='mr-2 mb-2 mt-3'>
                                        {
                                            is24h &&
                                            <span className="tagVN mr-2 mt-2" style={{ backgroundColor: '#dc3644', color: '#fff', fontSize: 33 }}>24h</span>
                                        }
                                        {
                                            isNoProof &&
                                            <span className="mr-2 mb-2" style={{
                                                color: 'red',
                                                border: '2px solid red',
                                                padding: '2px 10px',
                                                fontWeight: 'bold',
                                                fontSize: 33,
                                                borderRadius: 5,
                                            }}>No TAG cảnh báo</span>
                                        }
                                    </div>
                                </div>
                            </div>

                            {
                                !!type &&
                                <div className="row mb-3">
                                    <div className="col-6 text-right">Loại giỏ</div>
                                    <div className="col-6">
                                        <h4>{this.renderTypeBasket(type)}</h4>
                                    </div>
                                </div>
                            }
                        </div>
                        {
                            !!filterItems.length && showImg &&
                            <div className="InfoLef col-6 mb-3 d-flex justify-content-center flex-column">
                                <div className="d-flex">
                                    {
                                        filterItems.map((item, index) => {
                                            const { orderData = {}, barcode = '' } = { ...item }
                                            const { preview_image = '', design_front = '' } = { ...orderData }
                                            return (
                                                <div
                                                    key={index}
                                                    style={{ width: `${100 / filterItems.length}%` }}
                                                    className={`img-item position-relative d-flex flex-column ${index !== (filterItems.length - 1) ? 'mr-4' : ''}`}
                                                >
                                                    {barcode && <span className='font-weight-bold'>#{barcode}</span>}
                                                    <Popover
                                                        content={<img src={preview_image || design_front} alt='preview' />}
                                                        placement='left'
                                                        trigger="hover"
                                                        key={preview_image || design_front}
                                                    >
                                                        <img src={preview_image || design_front} style={{ height: '500px', objectFit: 'contain' }} alt='preview' />
                                                    </Popover>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                                {
                                    isShowImagePackaging &&
                                    <div className="show-image-packaging mt-2 d-flex flex-wrap">
                                        {
                                            imagePackaging.map((o, index) => (
                                                <div className='position-relative mr-2' key={index}>
                                                    <img
                                                        src={_.get(o, 'design')}
                                                        style={{ maxWidth: '300px', marginBottom: 10, cursor: 'pointer' }}
                                                        loading='lazy'
                                                        alt='preview'
                                                        onClick={() => this._handleChangeImage(_.get(o, 'design'), true)}
                                                    />
                                                </div>
                                            ))
                                        }
                                    </div>
                                }
                            </div>
                        }
                        {
                            !showImg && isShowImagePackaging &&
                            <div className="show-image-packaging col-4">
                                {
                                    imagePackaging.map((o, index) => (
                                        <div className='position-relative' key={index}>
                                            <img
                                                src={_.get(o, 'design')}
                                                style={{ maxWidth: '300px', marginBottom: 10, cursor: 'pointer' }}
                                                loading='lazy'
                                                alt='preview'
                                                onClick={() => this._handleChangeImage(_.get(o, 'design'), true)}
                                            />
                                        </div>
                                    ))
                                }
                            </div>
                        }
                        {
                            !!this.state.image && this.state.isOpenPreview &&
                            <Modal
                                visible={this.state.isOpenPreview}
                                onCancel={() => this._handleChangeImage('', false)}
                                closable={false}
                                footer={false}
                                width={"50vw"}
                                height={"75vh"}
                            >
                                <img
                                    src={this.state.image}
                                    alt="preview"
                                    width={"100%"}
                                    style={{ objectFit: 'contain' }}
                                />
                            </Modal>
                        }
                    </div>
                    <div className="ActionBatches col-12 mb-3">
                        <ReleaseBasketButton onClose={this.props.onClose} basket={result} />
                        <ExportQrCode
                            items={items}
                            basket={number}
                            totalItems={total_items}
                            className='ml-3'
                            isShowButtonQC={isShowButtonQC}
                            onSetData={onSetData}
                            reload={reload}
                            containerRef={containerRef}
                        />
                    </div>
                    <ListBasketItems items={vItems} type={type} />
                </div>
            </div>
        )
    }
}

BasketDetail.propTypes = {
    disabledCheckExists: PropTypes.bool,
    result: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
}

export default BasketDetail
